import React, { useState } from 'react'
import { MdArrowBack, MdArrowForward } from 'react-icons/md'
import { HiOutlineArrowLongRight } from 'react-icons/hi2'

import gsap, { Power4 } from 'gsap'

import ContainerSectionTestimonialsCircular from './styles'
import useAppConfig from '../../../../hooks/useAppConfig'
import ArrowCurvedSVG from '../../../../assets/svgs/arrow-curved'
import { logFirebaseEvent } from '../../../../services/firebase/analytics'

export default function SectionTestimonialsCircular() {
  const { appConfig } = useAppConfig()

  const [currentIndex, setCurrentIndex] = useState(0)

  const listSizeIndex =
    (appConfig?.appConfig?.testimonials?.testemonialList ?? []).length - 1

  function handleRandomChangeState() {
    if (currentIndex === listSizeIndex) {
      setCurrentIndex(0)
      return
    }

    setCurrentIndex(currentIndex + 1)
  }

  function hideAndDisplayNewCard() {
    const descriptionTestemonialById = window.document.getElementsByClassName(
      'card-testemonial-main-box'
    )
    const bottomTestemonialById = window.document.getElementsByClassName(
      'card-testemonial-main-box-bottom'
    )

    gsap.to(descriptionTestemonialById, {
      opacity: 0,
      duration: 0.3,
      animation: Power4.easeOut,
    })

    gsap.to(bottomTestemonialById, {
      opacity: 0,
      duration: 0.3,
      delay: 0.2,
      animation: Power4.easeOut,
      onComplete: () => {
        handleRandomChangeState()
      },
    })

    gsap.to(descriptionTestemonialById, {
      opacity: 1,
      duration: 0.3,
      animation: Power4.easeOut,
      delay: 0.5,
    })

    gsap.to(bottomTestemonialById, {
      opacity: 1,
      duration: 0.3,
      animation: Power4.easeOut,
      delay: 0.7,
    })
  }

  const handleANalyticsButtonClick = () => {
    logFirebaseEvent('button_click', {
      button_name: 'next_testemonial',
      screen_name: 'landing_page',
    })
  }

  const handleANalyticsButtonClick2 = () => {
    logFirebaseEvent('button_click', {
      button_name: 'new_page_testemonial',
      screen_name: 'landing_page',
    })
  }

  return (
    <ContainerSectionTestimonialsCircular
      color={
        appConfig?.appConfig?.styles?.forceSecondaryColor ? 'true' : undefined
      }
    >
      <div className="middle-section">
        <div className="m-s-top">
          <div className="label">
            {appConfig?.appConfig?.testimonials?.label}
            <span>
              <ArrowCurvedSVG />
            </span>
          </div>
          <div className="title">
            {appConfig?.appConfig?.testimonials?.title}
          </div>
        </div>
        <div className="m-s-bottom">
          <div className="m-s-b-box-testimonial">
            <div className="description card-testemonial-main-box">
              {
                appConfig?.appConfig?.testimonials?.testemonialList[
                  currentIndex
                ].description
              }
            </div>
            <div id="" className="space-left card-testemonial-main-box-bottom">
              <div className="box-person">
                <div className="box-person-photo">&nbsp;</div>
                <div className="box-person-data">
                  <div className="fullName">
                    {
                      appConfig?.appConfig?.testimonials?.testemonialList[
                        currentIndex
                      ].personFullName
                    }
                  </div>
                  <div className="personPosition">
                    {
                      appConfig?.appConfig?.testimonials?.testemonialList[
                        currentIndex
                      ].personPosition
                    }
                  </div>
                </div>
              </div>
              <div className="buttons-move">
                <div
                  className="button-left"
                  onClick={() => {
                    hideAndDisplayNewCard()
                    handleANalyticsButtonClick()
                  }}
                  aria-hidden
                >
                  <MdArrowBack />
                </div>
                <div
                  className="button-right"
                  onClick={() => {
                    hideAndDisplayNewCard()
                    handleANalyticsButtonClick()
                  }}
                  aria-hidden
                >
                  <MdArrowForward />
                </div>
              </div>
            </div>
          </div>
          <div className="image">&nbsp;</div>
        </div>
        <div
          className="button-action"
          aria-hidden
          onClick={() => {
            handleANalyticsButtonClick2()
          }}
        >
          {appConfig?.appConfig?.testimonials?.actionNextLabel}
          <HiOutlineArrowLongRight />
        </div>
      </div>
    </ContainerSectionTestimonialsCircular>
  )
}
